var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZabbix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21V42H21H42V21V1.90735e-06H21H0V21ZM29.6871 11.2137V12.3457L22.7473 20.8359L15.8156 29.3262L22.8949 29.3672L29.9824 29.4082L30.007 30.6633L30.0316 31.9102H21H11.9766V30.7781L11.9848 29.6543L18.9164 21.1641L25.848 12.6738L19.0969 12.6328L12.3457 12.5918L12.3211 11.3367L12.2965 10.0898H21H29.6953L29.6871 11.2137Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZabbix);
export default __webpack_public_path__ + "static/media/zabbix.267cf20177d82666cace3e46b850882d.svg";
export { ForwardRef as ReactComponent };